import { render, staticRenderFns } from "./SelloDatos.vue?vue&type=template&id=dbda50dc&scoped=true"
import script from "./SelloDatos.vue?vue&type=script&lang=js"
export * from "./SelloDatos.vue?vue&type=script&lang=js"
import style0 from "./SelloDatos.vue?vue&type=style&index=0&id=dbda50dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbda50dc",
  null
  
)

export default component.exports